import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Footer extends Component {
	constructor(props){
    super(props);
    
	}

  
	render() {
    
  	return (
      <footer>
        <div class="container">
          <ul class="footer-list">
              <li>&copy; KKBits {(new Date()).getFullYear()}</li>
              <li>·</li>
              <li><Link to="/privacy-policy" class="text-primary">Privacy & Terms</Link></li>
          </ul>
        </div>
      </footer>
    )
	}
}

export default Footer;